import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import logo from '../images/neoshiftBILogoWhite.png';

export default function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuthStore();
  
  // Redirect to dashboards if already authenticated
  if (isAuthenticated && !isLoading) {
    return <Navigate to="/dashboards" replace />;
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-surface-900 via-surface-950 to-primary-950 flex items-center justify-center p-4">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-500/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent-500/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary-600/10 rounded-full blur-3xl" />
      </div>
      
      {/* Grid pattern overlay */}
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}
      />
      
      <div className="relative w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src={logo} 
            alt="Neoshift BI" 
            className="h-12 mx-auto mb-2"
          />
          <p className="text-surface-400">AI-Powered Business Intelligence</p>
        </div>
        
        {/* Auth form container */}
        <div className="bg-surface-900/80 backdrop-blur-xl rounded-2xl border border-surface-800 shadow-2xl p-8 animate-fade-in">
          <Outlet />
        </div>
        
        {/* Footer */}
        <p className="text-center text-surface-500 text-sm mt-8">
          © {new Date().getFullYear()} Neoshift BI. All rights reserved.
        </p>
      </div>
    </div>
  );
}

